/* Cortazu locale fix (3 Nov 2026, go-live bugs). Custom file, not part of Hyper. Loaded from layout/theme.liquid.
   1. Links: buttons whose URL comes from a section setting or snippet as a plain path ("/collections/…", "/pages/…")
      are not prefixed with the language (/nl, /de) by Shopify, so on the NL/DE storefront they led back to English.
      On a non-default language every same-origin link without the prefix gets it (also links added later, e.g. lazy
      sections, drawers). /discount/<code>?redirect=<path> keeps /discount and prefixes the redirect target.
   2. Filters: collection filter values are translated per language (gender Men → Mannen / Männer), so an English
      filter URL (?filter.p.m.custom.gender=Men) on /nl or /de shows 0 products (e.g. after switching language on a
      filtered collection, or from link 1). On a collection page with a filter value that is not one of the values
      in the filter form, the value is mapped to the same gender in this language, or the parameter is dropped
      (whole collection rather than an empty grid), and the page is reloaded once with the fixed URL. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/' || root.charAt(0) !== '/') return;
  var pre = root.replace(/\/$/, '');                       // "/nl"
  var SKIP = /^\/(cdn|checkouts?|cart\/(add|change|update|clear)|account\/logout|customer_authentication|apps|services|localization|\.well-known|wpm|tools|recommendations\/products)/;
  var LANGS = /^\/(nl|de|en|fr|es|it)(\/|$)/;

  function fixPath(p) {
    if (!p || p.charAt(0) !== '/' || p.charAt(1) === '/') return null;
    if (LANGS.test(p) || SKIP.test(p)) return null;
    return pre + p;
  }
  function fix(a) {
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) === '#' || a.hasAttribute('hreflang') || a.closest('[data-disclosure-locale], localization-form')) return;
    var u;
    try { u = new URL(h, location.href); } catch (e) { return; }
    if (u.origin !== location.origin) return;
    if (/^\/discount\//.test(u.pathname)) {
      var r = u.searchParams.get('redirect');
      var nr = r && fixPath(r);
      if (nr) { u.searchParams.set('redirect', nr); a.setAttribute('href', u.pathname + u.search + u.hash); }
      return;
    }
    var np = fixPath(u.pathname);
    if (np) a.setAttribute('href', np + u.search + u.hash);
  }
  function run(scope) { (scope || document).querySelectorAll('a[href^="/"], a[href^="' + location.origin + '/"]').forEach(fix); }

  /* 2. filter values on collection pages */
  var G = { men: ['men', 'man', 'mannen', 'heren', 'herren', 'männer', 'manner'], women: ['women', 'woman', 'vrouwen', 'dames', 'damen', 'frauen'] };
  function genderOf(v) { v = (v || '').toLowerCase(); for (var k in G) if (G[k].indexOf(v) > -1) return k; return null; }
  /* Gender values per language as stored in the custom.gender metafield translations (checked 3 Nov 2026). The gender
     switch on collection pages is a link pair, not a filter input, so the values cannot be read from the form. */
  var GV = { nl: { men: 'Mannen', women: 'Vrouwen' }, de: { men: 'Männer', women: 'Frauen' } };
  function fixFilters() {
    if (!/\/collections\//.test(location.pathname) || location.search.indexOf('filter.') < 0) return;
    try { if (sessionStorage.getItem('cz:lf') === location.href) return; } catch (e) { return; }   // reload at most once per URL
    var lang = pre.slice(1).split('-')[0], gv = GV[lang];
    var u = new URL(location.href), changed = false;
    Array.from(u.searchParams.keys()).filter(function (k, i, a) { return k.indexOf('filter.') === 0 && k.indexOf('.gte') < 0 && k.indexOf('.lte') < 0 && a.indexOf(k) === i; }).forEach(function (k) {
      var vals = u.searchParams.getAll(k), out = [], ch = false;
      if (k === 'filter.p.m.custom.gender') {
        return;                                                       // handled before render by snippets/cz-locale-head.liquid
      } else {
        var inputs = document.querySelectorAll('input[name="' + k.replace(/"/g, '\\"') + '"]');
        if (!inputs.length) return;                                   // no filter input for it: leave it alone
        var opts = Array.from(inputs).map(function (i) { return i.value; });
        vals.forEach(function (v) { if (opts.indexOf(v) > -1) out.push(v); else ch = true; });   // unknown value: dropped
      }
      if (ch) { changed = true; u.searchParams.delete(k); out.forEach(function (v) { u.searchParams.append(k, v); }); }
    });
    if (changed) { try { sessionStorage.setItem('cz:lf', u.href); } catch (e) {} location.replace(u.href); }
  }

  function init() {
    run();
    try { fixFilters(); } catch (e) { /* never block the page */ }
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('a[href]')) fix(n); run(n); } }); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
